export default {
    trackStage(stage, value) {
        let ev = new CustomEvent("configuration-stage-changed", {
            detail: {
                stage: stage,
                value: value
            }
        });

        window.dispatchEvent(ev);
    },

    trackAdvanced(stage, data) {
        let ev = new CustomEvent("configuration-tracking-advanced", {
            detail: {
                stage: stage,
                data: data
            }
        });
  
        window.dispatchEvent(ev);
    }
}